import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { WelcomeComponent } from './welcome/welcome.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    title: 'Paquik',
    children: [
      { path: 'welcome', component: WelcomeComponent },
      {
        path: 'page',
        loadChildren: () =>
          import('../features/features.module').then((m) => m.FeaturesModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CoreRoutingModule {}
